import { JobRequest } from "../../entities/JobRequest";
import { Helpers } from "../../../jobs-flow/Helpers";
import { Invoice } from "../../entities/Invoice";
import PriceBook from "../../../price-book";
import { InputSelector } from "../../../components/InputSelector";
import { InvoiceItem } from "../../entities/InvoiceItem";

export const QuoteInvoiceFormInterface = {

    itemSelector:null,

    checkAdditionalFields() {
        const formId = this.form.getAttribute('id');
        this.calculateTotalPriceInForm(formId.replace('-container', ''));
        Helpers.checkAdditionalAttributes();
    },

    showRequestInfo(e) {
        const form = $(e.target).parents('.form-container').find('form');
        if(!$('#request-detals').html()) {
            const requestId = form.find('input[name=job_request_id]').val();
            const request = new JobRequest(requestId);
            const formHTML = request.getForm('request', 'view');
            request.pasteForm(formHTML, 'request-detals');

            const requestForm = $('#request-detals').find('.modal');
            requestForm.removeClass('fade');
            requestForm.removeClass('modal');
            requestForm.css('display', 'block');
            requestForm.find('.close-btn, .modal-btn').remove();

            request.completeForm('view-request');
        }

        if ($('#request-detals').css('width') == '550px') {
            $('#request-detals').css({'width': '0px', 'margin-right': '-5px'});
        } else {
            $('#request-detals').css({'width': '550px', 'margin-right': '20px'});
        }
    },

    duplicateInput(event){
        const root = $(event.target).parents('.item');
        const parent = $(event.target).parents('.item-section');
        if(root?.length && parent?.length && (event.target?.name || event.target?.id)){
            const selector = 'input'+event.target?.name ? `[name=${event.target?.name}]` : `#${event.target?.id}`
            const doubleInput = $(root.find(`.item-section`).not(parent)).find(selector);
            if(!doubleInput)
                return
            if(event.target.type == 'checkbox'|| event.target.type=='radio'){
                doubleInput.prop('checked', event.target.checked)
            }else{
                doubleInput.val($(event.target).val())
            }
        }
    },

    async getAddLineForm(formId){
        let result = await PriceBook.getForm(()=>{},'item', 'select');
        if(result){
            this.itemSelector = new InputSelector('#invoice-item-modal #item-select')
            $('#invoice-item-modal #item-select #create-new-item').on('click', async ()=>{
                await PriceBook.getForm(async (ev)=>{
                    let res = await PriceBook.createOrUpdate(ev)
                    if(res)
                        this.addAnotherLine(formId, res)
                }, 'item', 'create-for-invoice');
                $('#invoice-item-form input[name="name"]').val($(this.itemSelector.inputField).val())
            })
            $('#invoice-item-modal #select').on('click',async (ev)=>{
                let item_id = $(ev.currentTarget).attr('data-id')
                await PriceBook.getForm(async (ev)=>{
                    let data = PriceBook.getDataForInvoice(ev)
                    if(data)
                        this.addAnotherLine(formId, data)
                }, 'item', 'create-for-invoice', {item_id});
            })
            $(this.itemSelector.element).on('select-item', (ev)=>{
                if(ev.originalEvent.detail.value){
                    $('#invoice-item-modal #select').attr('data-id', ev.originalEvent.detail.value).removeAttr('disabled')
                }
            })
            $(this.itemSelector.element).on('no-data', (ev)=>{
                if(ev.originalEvent.detail.value){
                    $(this.itemSelector.noDataElement).find('.no-data-text').html(`<span>Create new reusable item <b>${ev.originalEvent.detail.value}</b></span>`)
                }
            })
        }
    },

    addAnotherLine(formId, itemData) {

        const lastItem = $(`#${formId}`).find('.item').last();
        const lastIndex = lastItem?.attr('id') ? parseInt(lastItem.attr('id').split('_').pop()) + 1 : 0;
        $(`#${formId}`).append(window.formLine);
        let item = $(`#${formId}`).find('.item').last()
        item.prop('id', `item_${lastIndex}`);
        item.find('.item-name').text(itemData.name)
        item.find('input[name="item"]').val(itemData.name)
        item.find('.item-description').text(itemData?.description ?? '-----------')
        item.find('input[name="details"]').val(itemData?.description ?? '')
        item.find('.item-type').text(itemData?.service_type)
        item.find('input[name="type"]').val(itemData?.type)
        if(itemData?.taxable)
            item.find('.item-taxable').removeClass('d-none')
        item.find('.form-group.quantity').text(itemData?.quantity ?? '1')
        item.find('input[name="quantity"]').val(itemData?.quantity ?? '1')
        item.find('.form-group.price').text('$ '+Number(itemData?.price).toFixed(2))
        item.find('input[name="cost"]').val(Number(itemData?.price))
        item.find('.form-group.cost').text(itemData?.unit_cost ? '$ '+Number(itemData?.unit_cost).toFixed(2) : '$ 0.00')
        item.find('input[name="unit_cost"]').val(itemData?.unit_cost ?? 0)
        item.find('.form-group.tax').text(itemData?.taxable ? 'Yes' : 'No')
        item.find('input[name="taxable"]').val(itemData?.taxable ? 1 : 0)

        const tax = itemData?.taxable ? Number($('#selected_tax_value').val()) / 100 : 0;
        const taxId = itemData?.taxable ? $('#selected_tax_id').val() : 0;
        if(itemData?.taxable){
            item.find('input[name="tax"]').val($('#selected_tax_value').val())
            item.find('input[name="tax_id"]').val(taxId)
        }

        const basePrice = Number(itemData?.price) * Number(itemData?.quantity);
        const total = basePrice * (1 + tax);              
        item.find('.form-group.total').text('$ '+total.toFixed(2));
        
        if($(`#${formId}`).find('.item').length != 1) {
            $(`#${formId}`).find('.item').find('.remove-line').removeClass('unvisible');
        } else {
            $(`#${formId}`).find('.item').first().find('.remove-line').addClass('unvisible');
        }
        this.calculateTotalPriceInForm(formId)
        this.checkIsDisabledBtns(formId)
    },
    removeLine(target) {
        const formId = $(target).parents('form').attr('id');
        $(target).parents('.item').remove();

        if($(`#${formId}`).find('.item').length == 1) {
            $(`#${formId}`).find('.item').first().find('.remove-line').addClass('unvisible');
        }
        this.calculateTotalPriceInForm(formId);
    },

    updateLine(item,itemData, formId){
        item.find('.item-name').text(itemData.name)
        item.find('input[name="item"]').val(itemData.name)
        item.find('.item-description').text(itemData?.description ?? '-----------')
        item.find('input[name="details"]').val(itemData?.description ?? '')
        item.find('.item-type').text(itemData?.service_type)
        item.find('input[name="type"]').val(itemData?.type)
        if(itemData?.taxable)
            item.find('.item-taxable').removeClass('d-none')
        else
            item.find('.item-taxable').addClass('d-none')
        item.find('.form-group.quantity').text(itemData?.quantity ?? '1')
        item.find('input[name="quantity"]').val(itemData?.quantity ?? '1')
        item.find('.form-group.price').text('$ '+Number(itemData?.price).toFixed(2))
        item.find('input[name="cost"]').val(Number(itemData?.price))
        item.find('.form-group.cost').text(itemData?.unit_cost ? '$ '+Number(itemData?.unit_cost).toFixed(2) : '$ 0.00')
        item.find('input[name="unit_cost"]').val(itemData?.unit_cost ?? 0)
        item.find('.form-group.tax').text(itemData?.taxable ? 'Yes' : 'No')
        item.find('input[name="taxable"]').val(itemData?.taxable ? 1 : 0)
        const tax = itemData?.taxable ? Number($('#selected_tax_value').val()) / 100 : 0;
        const taxId = itemData?.taxable ? $('#selected_tax_id').val() : 0;
        if(itemData?.taxable){
            item.find('input[name="tax"]').val($('#selected_tax_value').val())
            item.find('input[name="tax_id"]').val(taxId)
        }else{
            item.find('input[name="tax"]').val('')
            item.find('input[name="tax_id"]').val('')
        }

        const basePrice = Number(itemData?.price) * Number(itemData?.quantity);
        const total = basePrice * (1 + tax);              
        item.find('.form-group.total').text('$ '+total.toFixed(2));

        this.calculateTotalPriceInForm(formId)
        this.checkIsDisabledBtns(formId)
    },

    editLine(target){

        const formId = $(target).parents('form').attr('id');
        const item = $($(target).parents('.item')[0])
        PriceBook.getForm(async (ev)=>{
            let data = PriceBook.getDataForInvoice(ev)
            if(data)
                this.updateLine(item, data, formId)
        }, 'item', 'update-for-invoice').then(()=>{
            let data = {}
            data.name = item.find('input[name="item"]').val()
            data.description = item.find('input[name="details"]').val()
            data.type = item.find('input[name="type"]').val()
            data.quantity = item.find('input[name="quantity"]').val()
            data.price = item.find('input[name="cost"]').val()
            data.unit_cost = item.find('input[name="unit_cost"]').val()
            data.taxable = item.find('input[name="taxable"]').val() == '1'

            $('#invoice-item-modal input[name="name"]').val(data.name)
            $(`#invoice-item-modal select[name="type"] option[value=${data.type}]`).attr('selected','selected')
            $('#invoice-item-modal input[name="quantity"]').val(data.quantity)
            $('#invoice-item-modal input[name="price"]').val(data.price)
            $('#invoice-item-modal input[name="unit_cost"]').val(data.unit_cost)
            $('#invoice-item-modal textarea[name="description"]').val(data.description)
            if(data.taxable)
                $('#invoice-item-modal input[name="taxable"]').prop('checked',true)
        });
    },

    calculateTotalPriceInForm: (formId=null) => {
        if(!formId) formId = $(event.target).parents('form').attr('id');
        const itemRows = $(`#${formId} .item`);

        let subTotalPrice = 0;
        let tax = 0;

        const baseTax = Number($('#selected_tax_value').val());
        const taxId = $('#selected_tax_id').val();

        for (let itemRow of itemRows) {
            itemRow = $(itemRow);

            let quantity = Number(itemRow.find('input[name="quantity"]').val())
            let taxable = itemRow.find('input[name="taxable"]').val() == '1'
            let price = Number(itemRow.find('input[name="cost"]').val())
            let acceptTax=0
            if(taxable){
                itemRow.find('input[name="tax"]').val(baseTax)
                itemRow.find('input[name="tax_id"]').val(taxId)
                acceptTax = baseTax/100
            }else{
                itemRow.find('input[name="tax"]').val('')
                itemRow.find('input[name="tax_id"]').val('')
            }

            subTotalPrice += price * quantity;
            const itemTax = taxable ? (price * quantity)*acceptTax : 0;
            const total = (price * quantity)+itemTax
            itemRow.find('.form-group.total').text('$ '+total.toFixed(2));
            tax += itemTax;

        }

        $(`#${formId}-container .output .sub-total .value`).text(`$ ${subTotalPrice.toFixed(2)}`);
        $(`#${formId}-container .output .tax .value`).text(`$ ${tax.toFixed(2)}`);
        $(`#${formId}-container .output .total .value`).text(`$ ${(subTotalPrice + tax).toFixed(2)}`);
    },

    checkIsDisabledBtns(formId){
        let serviceId = $('.custom-select-new #service_id').val() != '0'
        let customerId = $('.custom-select-new #customer_id').val() != '0'
        let itemsCount = $(`#${formId} .item`).length
        if(serviceId && customerId && itemsCount){
            $('.btn-controls #edit, .btn-controls #create').attr('disabled', false);
            $('.btn-controls #preview').attr('disabled', false);
            $('.btn-controls #save-draft').attr('disabled', false);
        }else{
            $('.btn-controls #edit, .btn-controls #create').attr('disabled', true);
            $('.btn-controls #preview').attr('disabled', true);
            $('.btn-controls #save-draft').attr('disabled', true);
        }
    },

    collectDataInForm: (formId) => {

        let tax_id = null;
        
        if ($('form .item>input[name=taxable][value="1"]').length > 0 && $('#selected_tax_id').val() !== "") {
            tax_id = $('#selected_tax_id').val();
        } 

        let data = {
            items: [],
            job_request_id: $('[name=job_request_id]').val(),
            id: $('.entity_id').val(),
            tax_id: tax_id,
        }

        const items = $(`#${formId} .item`);
        for (let item of items) {
            const itemJQ = $(item);
            let itemData = {
                id: itemJQ.find(`input[name=item_id]`).val(),
                item: itemJQ.find(`input[name=item]`).val(),
                details: itemJQ.find(`input[name=details]`).val(),
                quantity: itemJQ.find(`input[name=quantity]`).val(),
                cost: itemJQ.find(`input[name=cost]`).val(),
                unit_cost: itemJQ.find(`input[name=unit_cost]`).val(),
                type: itemJQ.find(`input[name=type]`).val(),
                taxable: Boolean(Number(itemJQ.find(`input[name=taxable]`).val()))
            }
            let taxable = itemJQ.find('.form-group.tax').text().trim() == 'Yes'
            itemData.tax_id = taxable ? $('#selected_tax_id').val() ?? null : null,
            data.items.push(itemData);
        }

        $('input[name=expiration_date]').length && (data.expiration_date = $('input[name=expiration_date]').val());
        $('input[name=down_payment]').val() && (data.down_payment = $('input[name=down_payment]').val());
        $('input[name=start_date_time]').length && (data.start_date_time = $('input[name=start_date_time]').val());
        $('input[name=due_days]').val() && (data.due_days = $('input[name=due_days]').val());
        $('input[name=late_fee_percent]').val() && (data.late_fee_percent = $('input[name=late_fee_percent]').val());
        $('input[name=quote_id]').val() && (data.quote_id = $('input[name=quote_id]').val());
        $('input[name=completion_date]').length && (data.completion_date = $('input[name=completion_date]').val());

        if (!data.job_request_id) {
            data.customer_id = $('[name=customer_id]').val();
            data.service_id = $('[name=service_id]').val();
        }

        return data;
    },

    preview(formId) {
        const data = this.collectDataInForm(formId);
        const params = btoa(JSON.stringify(data));
        const entityClass = formId.split('-')[1];
        const previewUrl = `/jobs-flow/${entityClass}/preview`;

        $.ajax({
            url: previewUrl,
            method: 'POST',
            data: { data: params },

            success: (response) => {
                localStorage.setItem(`${entityClass}_preview_data`, response);
                window.open(previewUrl, '_blank');
            }
        })

    },
}
